/* Skye direct-to-checkout.
 *
 * Extracted from two byte-identical copies (sections/prod-cro-conversion.liquid and
 * snippets/skye-buy-box.liquid) that had to be kept in sync by hand. Behaviour is
 * unchanged from those copies except for the empty-cart skip below.
 *
 * Why AJAX and not the cart permalink: /cart/{id}:{qty}?selling_plan= silently DROPS
 * the selling plan, so the item adds as a one-time purchase at full price. The AJAX
 * cart is what makes a subscription actually stick.
 */
(function () {
  var cartCount = (typeof window.__skyeCartCount === 'number') ? window.__skyeCartCount : undefined;

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) { cartCount = c.item_count; window.__skyeCartCount = c.item_count; } })
      .catch(function () {});
  }

  /* bfcache restore is the back-and-retap path the clear was written for: the snapshot
     the server rendered is stale by then, so re-read before trusting it. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  function go(ctx) {
    var form = ctx.form,
        variantInput = ctx.variantInput,
        sellingPlanInput = ctx.sellingPlanInput,
        checkoutBtn = ctx.checkoutBtn;

    var variant = variantInput.value;
    /* Safety net — never expected, variantInput always has a value. */
    if (!variant) { form.submit(); return; }

    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = (qtyEl && qtyEl.value) || '1';
    var plan = sellingPlanInput.value;

    var item = { id: Number(variant), quantity: Number(qty) || 1 };
    if (plan) item.selling_plan = Number(plan);

    var resetBtn = function () {
      checkoutBtn.dataset.navigating = '';
      checkoutBtn.classList.remove('is-loading');
    };

    /* Clearing keeps checkout to exactly this selection and stops stale one-time lines
       stacking on a back-and-retap. It is only needed when something is actually in the
       cart, which on paid-traffic landings it usually is not — and skipping it removes a
       round trip from the most valuable tap on the site, plus a burst of spurious
       product_removed_from_cart events that inflate Meta's AddToCart.
       `!== 0` on purpose: an unknown count (asset failed, storage off) still clears. */
    var needsClear = cartCount !== 0;
    var first = needsClear ? fetch('/cart/clear.js', { method: 'POST' }) : Promise.resolve();

    first
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(item)
        });
      })
      .then(function (res) {
        if (!res.ok) { resetBtn(); return; }
        cartCount = window.__skyeCartCount = item.quantity;
        window.location.href = '/checkout';
      })
      .catch(resetBtn);
  }

  window.SkyeCheckout = { go: go, refreshCartCount: refresh };
})();
